import { render, staticRenderFns } from "./mutationList.vue?vue&type=template&id=0720135e&scoped=true"
import script from "./mutationList.vue?vue&type=script&lang=js"
export * from "./mutationList.vue?vue&type=script&lang=js"
import style0 from "./mutationList.vue?vue&type=style&index=0&id=0720135e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0720135e",
  null
  
)

export default component.exports